// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e7803bc9","455":"38ceb504","488":"896e77ea","977":"cf2ad8f7"}[chunkId] + ".chunk.js";
};